import { html } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';
import { virtual } from 'haunted';
import { FormInputSwitch } from '@outbook/webcomponents-form-input-switch';

export const PrefBasicSwitch = virtual(({ title, setPref, pref, name }) => {
  const handleChange = function (ev) {
    setPref(ev.detail.checked);
  };
  return FormInputSwitch({
    name,
    size: 'S',
    eventFn: handleChange,
    isChecked: Boolean(pref),
    label: title
  });
});

export const PrefBasicSwitchSimple = virtual(
  ({ title, setPref, pref, name }) => {
    function handlePref(ev) {
      setPref(ev.currentTarget.checked);
    }
    return html`
      <label for="${name}" class="inline-flex items-center cursor-pointer">
        <input
          id="${name}"
          type="checkbox"
          name="${name}"
          @change="${handlePref}"
          checked="${ifDefined(pref ? 'checked' : undefined)}"
          class="sr-only peer"
        />
        <div
          class="relative w-11 h-6 bg-gray-200 rounded-full dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:rtl:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-emerald-700 dark:peer-checked:bg-emerald-400 peer-focus-visible:outline outline-offset-2 outline-emerald-700 dark:outline-emerald-300"
        ></div>
        <span class="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300"
          >${title}</span
        >
      </label>
    `;
  }
);

export const PrefBasicRadio = virtual(
  ({ options, title, pref, setPref, name }) => {
    function handlePref(show) {
      return () => {
        setPref(show);
      };
    }
    return html`
      <div class="flex items-center">
        <p class="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">
          ${title}:
        </p>
        <ul
          class="flex ml-2 rounded-sm bg-gray-200 dark:bg-gray-700 p-1"
          role="radiogroup"
        >
          ${options.map((item, index) => {
            const isSelected = pref === item.value;
            return html`
              <li class="${ifDefined(index > 0 ? 'ml-2' : undefined)}">
                <label class="block" for="${name}-${index}">
                  <input
                    id="${name}-${index}"
                    type="radio"
                    name="${name}"
                    @change="${handlePref(item.value)}"
                    checked="${ifDefined(isSelected ? 'checked' : undefined)}"
                    class="peer sr-only"
                  />
                  <span
                    class="block cursor-pointer select-none rounded-sm p-1 text-center text-sm text-gray-900 dark:text-white peer-checked:bg-emerald-700 dark:peer-checked:bg-emerald-300 peer-checked:font-bold peer-checked:text-white dark:peer-checked:text-gray-900 peer-focus-visible:outline outline-offset-2 outline-emerald-700 dark:outline-emerald-300"
                  >
                    ${item.label}</span
                  >
                </label>
              </li>
            `;
          })}
        </ul>
      </div>
    `;
  }
);
